// Pushes a custom event onto Google Tag Manager's dataLayer (GTM snippet lives in
// public/index.html). GTM forwards these to GA4 — each event name here needs a
// matching GA4 Event tag + Custom Event trigger in the GTM container to actually
// reach GA4. Never throws: analytics must not be able to break the app.
//
// Deliberately never sends keywords, emails, or full scanned URLs — only the
// scanned site's hostname and counts/flags. Keywords can be sensitive, and GA4's
// terms prohibit sending anything that could be personal data.
export function trackEvent(event, params = {}) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch {
    // ignore
  }
}

export function hostnameOf(url) {
  try {
    return new URL(/^https?:\/\//i.test(url) ? url : `https://${url}`).hostname.replace(/^www\./, "");
  } catch {
    return undefined;
  }
}
